@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
            @if (info(); as content) {
                <kno2-info-popover
                    class="ml-1 align-middle"
                    [title]="infoTitle()"
                    [content]="content" />
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    <input
        pInputText
        [type]="type()"
        [placeholder]="placeholder() ?? ''"
        [id]="inputId()"
        [invalid]="showInvalid()"
        [attr.readonly]="isReadonly() ? '' : null"
        [pSize]="size()"
        [maxlength]="maxlength()"
        [pattern]="pattern()"
        [mask]="mask()"
        [dropSpecialCharacters]="dropSpecialCharacters()"
        [validation]="false"
        [disabled]="disabled()"
        [attr.disabled]="disabled() ? '' : null"
        [style]="fullWidthStyle"
        [ngModel]="displayedValue()"
        (ngModelChange)="handleChange($event)"
        (blur)="markTouched()"
        [ngModelOptions]="standaloneNgModel" />
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
